import { useAnalyticContext } from '@application/analytic/analytic_link/mod';
import { withTranslation } from '@application/i18n/with_translation';
import { CellulaFormSubmitData, Flex } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { Title } from '@component/title.component';
import { TopBar } from '@component/top_bar.component';
import { Skeleton } from '../../components/skeleton';
import { useBasket } from '../../hooks/use-basket';
import { CreateNewMessageAnalyticActions } from '../../hooks/use-create-new-message';
import { ParticipantsForm } from './participants_form.component';
import { useAccess } from './use-access';

export const ScreenAccess = () => {
	const { basket } = useBasket();
	const { data, submit } = useAccess();
	const { trackEvent } = useAnalyticContext();
	const participants = basket?.Participants ?? [];

	const handleAccessChange = (value: string[]) => {
		trackEvent(`Changed "Access" to "${value}"`);
	};

	const handleSubmit = (data: CellulaFormSubmitData) => {
		submit({ access: data.access });
	};

	const handleInvalidSubmit = () => {
		trackEvent(CreateNewMessageAnalyticActions.FormIsInvalid);
	};

	if (basket == null || participants.length === 0) {
		// While participants are empty useAccess auto-redirects to the conclusion screen.
		return <Skeleton />;
	}

	return (
		<>
			<TopBar.Content goBack />

			<Flex grow={1} gap={tokens.spacing.x2}>
				<Title title={withTranslation('View.Booking.ScreenAccess.Title')} titleSize='small' />
				<ParticipantsForm
					participants={participants}
					defaultAccess={data.access}
					submitLabel={withTranslation('PW.Common.Next')}
					onSubmit={handleSubmit}
					onInvalid={handleInvalidSubmit}
					onAccessChange={handleAccessChange}
					onSubmitClick={() => trackEvent('Clicked next button')}
				/>
			</Flex>
		</>
	);
};
